export const LAZADA_BONUS_DEEPLINK = {
  id: 'lazada_bonus_deeplink',
  url: 'https://c.lazada.co.th/t/c.bA74Ec?sub_aff_id=lazada_bonus_deeplink',
  label: 'ช้อปบน Lazada',
  sponsor: 'Lazada',
};

export const AFFILIATE_MESSAGES = {
  afterDream: 'ได้เลขเด็ดแล้ว? ช้อปของมงคลรับโชคบน Lazada',
  afterStats: 'เช็คเลขเสร็จแล้ว ลองดูดีลเด็ดบน Lazada',
  general: 'ช้อปของดีราคาพิเศษ รับโชคไปด้วย',
};
